import {
  Fragment,
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { Card, FormGroup, Input, Label } from "reactstrap";
import { Multiselect } from "multiselect-react-dropdown";
import ReactSlider from "react-slider";
import { Modal } from "reactstrap";
import {
  formattedContainerId,
  formattedStatus,
  formattedTypeContainer,
} from "../../components/formatted/FormattedText";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { ContainersListPdf } from "../../components/download/Container/ContainersListPdf.js";
import { pdf } from "@react-pdf/renderer";
import { toast } from "react-toastify";
import { azureSASTokenToUrl } from "../../components/formatted/FormattedAzureSasToken.js";
import reactImageSize from "react-image-size";
import { getHistoryCycleContainer } from "../../services/container.js";
import { LoadingScreen } from "../../components/loader/LoadingScreen.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sendReportingMail } from "../../services/users.js";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import {
  TableFilterClearLink,
  hasActiveClearableFilters,
} from "../../ui/components/filters";

const ContainerFilter = ({
  arrayFilterFillingLevel,
  setArrayFilterFIllingLevel,
  keywordFilterOptions,
  keywordFilter,
  setKeywordFilter,
  contentKeysFiltered,
  setContentKeysFiltered,
  addressKeysFiltered,
  setAddressKeysFiltered,
  statusKeysFiltered,
  setStatusKeysFiltered,
  typeKeysFiltered,
  setTypeKeysFiltered,
  volumeKeysFiltered,
  setVolumeKeysFiltered,
  positioningKeysFiltered,
  setPositioningKeysFiltered,
  cleanFilters,
  cleanAllFilters,
  setCleanAllFilters,
  setTypeFillingFilter,
  typeFillingFilter = "all",
  searchText = "",
  multiselectTypeRef,
  multiselectContentRef,
  multiselectAddressRef,
  multiselectStatusRef,
  multiselectVolumeRef,
  multiselectPositioningRef,
  hourKeysFiltered,
  setHourKeysFiltered,
  multiselectHour,
  data,
  settings,
  displayToBlock,
  handleDisplayMode,
  displayMode,
  screenWidth,
  screenWidthToForceBlockDisplay,
  activeMonitoringTab,
  lastEnrichmentTime,
  onRefresh,
  isEnriching,
  fieldSort,
  setFieldSort,
  onShareButtonRender = null,
}) => {
  const { t, i18n } = useTranslation();
  const cookieValue = Cookies.get("containerFilter");
  const parsedValue = cookieValue ? JSON.parse(cookieValue) : false;
  const [filterActive, setFilterActive] = useState(parsedValue);
  const [loadScreen, setLoadScreen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [subject, setSubject] = useState(
    t("Status report on the filling level of your containers"),
  );
  const today = new Date().toLocaleDateString(i18n.language, {
    day: "2-digit",
    month: "2-digit",
  });
  const [message, setMessage] = useState(
    `${t("Hello")},\n\n${t(
      "Please find attached the current filling levels of the containers as they stand",
    )} (${today}).`,
  );
  const [userToSendMail, setUserToSendMail] = useState([]);
  const [action, setAction] = useState("export");
  const [pdfFiles, setpdfFiles] = useState([]);
  const [selectWidth, setSelectWidth] = useState(100);
  const [labelWidth, setLabelWidth] = useState(100);
  const [displayButtonWidth, setDisplayButtonWidth] = useState(180);
  const measureRef = useRef(null);
  const labelMeasureRef = useRef(null);
  const displayMeasureRef = useRef(null);
  const selectRef = useRef(null);

  const showClearFilters = useMemo(
    () =>
      hasActiveClearableFilters([
        {
          value: Array.isArray(keywordFilter) ? keywordFilter : [],
          defaultValue: [],
        },
        { value: contentKeysFiltered, defaultValue: [] },
        { value: addressKeysFiltered, defaultValue: [] },
        { value: statusKeysFiltered, defaultValue: [] },
        { value: typeKeysFiltered, defaultValue: [] },
        { value: volumeKeysFiltered, defaultValue: [] },
        { value: positioningKeysFiltered, defaultValue: [] },
        { value: hourKeysFiltered, defaultValue: [] },
        { value: typeFillingFilter, defaultValue: "all" },
        { value: searchText, defaultValue: "" },
        {
          value:
            arrayFilterFillingLevel?.[0] !== 0 ||
            arrayFilterFillingLevel?.[1] !== 100
              ? 1
              : 0,
          defaultValue: 0,
        },
      ]),
    [
      keywordFilter,
      contentKeysFiltered,
      addressKeysFiltered,
      statusKeysFiltered,
      typeKeysFiltered,
      volumeKeysFiltered,
      positioningKeysFiltered,
      hourKeysFiltered,
      typeFillingFilter,
      searchText,
      arrayFilterFillingLevel,
    ],
  );

  const imageDimensions = async function getDimensions(src) {
    try {
      if (!src) throw new Error("Image source is undefined or empty");

      const dimensions = await reactImageSize(src);
      return dimensions;
    } catch (error) {
      console.error(
        `Error getting image dimensions for ${src}:`,
        error.message,
      );
      return { width: 0, height: 0 };
    }
  };

  const labeledkeywordFilterOptions = keywordFilterOptions.map((keyword) => {
    if (keyword.type === "type") {
      keyword = { ...keyword, key: formattedTypeContainer(keyword.key) };
    } else if (keyword.type === "id") {
      keyword = {
        ...keyword,
        key: formattedContainerId(keyword.key) + keyword.key,
      };
    } else if (keyword.type === "status") {
      keyword = { ...keyword, key: formattedStatus(keyword.key) };
    }
    return keyword;
  });

  const listDayHours = () => {
    const now = new Date();
    const hours = [];
    for (let hour = 0; hour <= now.getHours(); hour++) {
      const date = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hour,
      );
      if (date.getDate() === now.getDate()) {
        hours.push({ key: ` ${date.getHours()}h`, value: date.toISOString() });
      }
    }
    return hours;
  };

  const typeKeys = labeledkeywordFilterOptions.filter((v) => v.type === "type");
  const contentKeys = labeledkeywordFilterOptions.filter(
    (v) => v.type === "waste",
  );
  const addressKeys = labeledkeywordFilterOptions.filter(
    (v) => v.type === "address",
  );
  const statusKeys = labeledkeywordFilterOptions.filter(
    (v) => v.type === "status",
  );
  const volumeKeys = labeledkeywordFilterOptions.filter(
    (v) => v.type === "volume",
  );
  const positioningKeys = labeledkeywordFilterOptions.filter(
    (v) => v.type === "id" && v.name !== "",
  );
  const listHours = listDayHours().reverse();

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleRemovePdf = (indexToRemove) => {
    setpdfFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const downloadPdf = () => {
    setLoadScreen(true);
    pdfFiles.forEach((file) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file.pdfBlob);
      link.download = file.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
    toggle();
    setLoadScreen(false);
    setpdfFiles([]);
    toast.success(t("Your file has been successfully downloaded"), {
      className: "custom-toast",
    });
  };

  const sendMail = async () => {
    setLoadScreen(true);
    try {
      const attachments = [];

      for (const file of pdfFiles) {
        const pdfBase64 = await blobToBase64(file.pdfBlob);
        attachments.push({
          filename: file.filename,
          mimetype: "application/pdf",
          content: pdfBase64,
        });
      }

      const payload = {
        usersToSendMail: userToSendMail,
        subject,
        message,
        attachments,
      };

      await sendReportingMail(payload);

      toast.success(t("Email sent successfully"), {
        className: "custom-toast",
      });
    } catch (err) {
      console.error(`${t("Error sending PDF")} :`, err);
      toast.error(t("Error sending the email"));
    }
    toggle();
    setpdfFiles([]);
    setLoadScreen(false);
  };

  const generatePdf = useCallback(async () => {
    setLoadScreen(true);
    const finalData = [];

    for (const item of data) {
      const itemDate = new Date(item._time);
      const daysSinceCapture = Math.floor(
        (Date.now() - itemDate.getTime()) / 86400000,
      );

      const isAlert = daysSinceCapture <= settings.alertNumberOfDays;
      const isUncharacterized = !item.characterization;
      if (!isAlert || !isUncharacterized) continue;

      try {
        const dimensions = await imageDimensions(
          azureSASTokenToUrl(item.image_url),
        );
        const enrichedItem = { ...item, imageDimensions: dimensions };

        const response = await getHistoryCycleContainer(
          { currentCycle: true, getLevelLastRotation: true },
          item._id,
        );

        if (response.status === 200) {
          const history = response.data.historyCycle;
          const lastCycle = history?.[0];

          if (lastCycle) {
            enrichedItem.numberOfAnomaly =
              response.data.numberOfAnomaly ?? null;
            enrichedItem.numberOfStars = response.data.numberOfStars ?? null;
            enrichedItem.numberOfPackmat =
              response.data.numberOfPackmat ?? null;
            enrichedItem.weightKG = lastCycle.mass ?? null;
          }
        }

        finalData.push(enrichedItem);
      } catch (error) {
        console.error(`${t("Error for the container")} ${item._id} :`, error);
      }
    }

    const containersData = finalData.reduce((acc, item) => {
      const address = item.addressName;
      if (!acc[address]) acc[address] = [];
      acc[address].push(item);
      return acc;
    }, {});

    const files = [];
    for (const address in containersData) {
      const doc = <ContainersListPdf data={containersData[address]} />;
      const pdfFilename = `${address}.pdf`;
      const pdfBlob = await pdf(doc).toBlob();
      files.push({
        filename: pdfFilename,
        pdfBlob: pdfBlob,
      });
    }
    setpdfFiles(files);
    setLoadScreen(false);
  }, [data, settings, t]);

  const toggle = () => {
    setAction("export");
    setUserToSendMail([]);
    setIsOpen(!isOpen);
    setSubject(t("Status report on the filling level of your containers"));
    setMessage(
      `${t("Hello")},\n\n${t(
        "Please find attached the current filling levels of the containers as they stand",
      )} (${today}).`,
    );
  };

  const getSelectedOptionText = () => {
    if (fieldSort === "filling_level") return t("Filling");
    if (fieldSort === "predictionOverflow") return t("Overflow prediction");
    if (fieldSort === "wasteName") return t("Waste Category");
    if (fieldSort === "addressId") return t("Address");
    if (fieldSort === "status") return t("Status");
    return t("Filling");
  };

  useEffect(() => {
    if (measureRef.current) {
      const width = measureRef.current.offsetWidth;
      setSelectWidth(width + 40);
    }
    if (labelMeasureRef.current) {
      const width = labelMeasureRef.current.offsetWidth;
      setLabelWidth(width);
    }
    if (displayMeasureRef.current) {
      const width = displayMeasureRef.current.offsetWidth;
      setDisplayButtonWidth(width + 48);
    }
  }, [fieldSort, displayToBlock, t, i18n.language]);

  useEffect(() => {
    if (onShareButtonRender && activeMonitoringTab !== "planning") {
      const shareButton = (
        <button
          className={`create-button flex items-center gap-2 justify-center border-0 transition-colors ${loadScreen || data.length === 0 ? "disabled" : ""}`}
          style={{
            backgroundColor:
              loadScreen || data.length === 0
                ? "#d1d5db"
                : "var(--akanthas-cyan)",
            color: "#fff",
            height: "40px",
          }}
          onClick={() => {
            if (!loadScreen && data.length > 0) {
              setIsOpen(true);
              generatePdf();
            }
          }}
          disabled={loadScreen || data.length === 0}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_share"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="16"
              height="16"
            >
              <rect width="16" height="16" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_share)">
              <path
                d="M11.3333 14.6668C10.7777 14.6668 10.3055 14.4724 9.91659 14.0835C9.5277 13.6946 9.33325 13.2224 9.33325 12.6668C9.33325 12.6002 9.34992 12.4446 9.38325 12.2002L4.69992 9.46683C4.52214 9.6335 4.31659 9.76405 4.08325 9.8585C3.84992 9.95294 3.59992 10.0002 3.33325 10.0002C2.7777 10.0002 2.30547 9.80572 1.91659 9.41683C1.5277 9.02794 1.33325 8.55572 1.33325 8.00016C1.33325 7.44461 1.5277 6.97239 1.91659 6.5835C2.30547 6.19461 2.7777 6.00016 3.33325 6.00016C3.59992 6.00016 3.84992 6.04739 4.08325 6.14183C4.31659 6.23627 4.52214 6.36683 4.69992 6.5335L9.38325 3.80016C9.36103 3.72239 9.34714 3.64739 9.34159 3.57516C9.33603 3.50294 9.33325 3.42239 9.33325 3.3335C9.33325 2.77794 9.5277 2.30572 9.91659 1.91683C10.3055 1.52794 10.7777 1.3335 11.3333 1.3335C11.8888 1.3335 12.361 1.52794 12.7499 1.91683C13.1388 2.30572 13.3333 2.77794 13.3333 3.3335C13.3333 3.88905 13.1388 4.36127 12.7499 4.75016C12.361 5.13905 11.8888 5.3335 11.3333 5.3335C11.0666 5.3335 10.8166 5.28627 10.5833 5.19183C10.3499 5.09739 10.1444 4.96683 9.96659 4.80016L5.28325 7.5335C5.30547 7.61127 5.31936 7.68627 5.32492 7.7585C5.33047 7.83072 5.33325 7.91127 5.33325 8.00016C5.33325 8.08905 5.33047 8.16961 5.32492 8.24183C5.31936 8.31405 5.30547 8.38905 5.28325 8.46683L9.96659 11.2002C10.1444 11.0335 10.3499 10.9029 10.5833 10.8085C10.8166 10.7141 11.0666 10.6668 11.3333 10.6668C11.8888 10.6668 12.361 10.8613 12.7499 11.2502C13.1388 11.6391 13.3333 12.1113 13.3333 12.6668C13.3333 13.2224 13.1388 13.6946 12.7499 14.0835C12.361 14.4724 11.8888 14.6668 11.3333 14.6668ZM11.3333 13.3335C11.5221 13.3335 11.6805 13.2696 11.8083 13.1418C11.936 13.0141 11.9999 12.8557 11.9999 12.6668C11.9999 12.4779 11.936 12.3196 11.8083 12.1918C11.6805 12.0641 11.5221 12.0002 11.3333 12.0002C11.1444 12.0002 10.986 12.0641 10.8583 12.1918C10.7305 12.3196 10.6666 12.4779 10.6666 12.6668C10.6666 12.8557 10.7305 13.0141 10.8583 13.1418C10.986 13.2696 11.1444 13.3335 11.3333 13.3335ZM3.33325 8.66683C3.52214 8.66683 3.68047 8.60294 3.80825 8.47516C3.93603 8.34739 3.99992 8.18905 3.99992 8.00016C3.99992 7.81127 3.93603 7.65294 3.80825 7.52516C3.68047 7.39739 3.52214 7.3335 3.33325 7.3335C3.14436 7.3335 2.98603 7.39739 2.85825 7.52516C2.73047 7.65294 2.66659 7.81127 2.66659 8.00016C2.66659 8.18905 2.73047 8.34739 2.85825 8.47516C2.98603 8.60294 3.14436 8.66683 3.33325 8.66683ZM11.3333 4.00016C11.5221 4.00016 11.6805 3.93627 11.8083 3.8085C11.936 3.68072 11.9999 3.52239 11.9999 3.3335C11.9999 3.14461 11.936 2.98627 11.8083 2.8585C11.6805 2.73072 11.5221 2.66683 11.3333 2.66683C11.1444 2.66683 10.986 2.73072 10.8583 2.8585C10.7305 2.98627 10.6666 3.14461 10.6666 3.3335C10.6666 3.52239 10.7305 3.68072 10.8583 3.8085C10.986 3.93627 11.1444 4.00016 11.3333 4.00016Z"
                fill="white"
              />
            </g>
          </svg>
          <span className="text-sm font-medium text-white">{t("Share")}</span>
          <i className="fas fa-chevron-down text-xs text-white"></i>
        </button>
      );
      onShareButtonRender(shareButton);
    } else if (onShareButtonRender) {
      onShareButtonRender(null);
    }

    return () => {
      onShareButtonRender?.(null);
    };
  }, [
    onShareButtonRender,
    activeMonitoringTab,
    loadScreen,
    data.length,
    t,
    generatePdf,
  ]);

  return (
    <>
      <div className="w-full flex justify-between items-center">
        <div className="flex items-center gap-2">
          <button
            className="create-button flex items-center gap-2 justify-center bg-white border border-gray-300 hover:bg-gray-50 transition-colors w-[112px]"
            style={{
              backgroundColor: "#fff",
              borderColor: "#d1d5db",
              height: "40px",
            }}
            onClick={() => {
              const newValue = !filterActive;
              setFilterActive(newValue);
              Cookies.set("containerFilter", JSON.stringify(newValue), {
                secure: true,
              });
            }}
          >
            <svg
              width="16"
              height="12"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="flex-shrink-0"
            >
              <path
                d="M4.66667 8V6.66667H7.33333V8H4.66667ZM2 4.66667V3.33333H10V4.66667H2ZM0 1.33333V0H12V1.33333H0Z"
                fill="#000000"
              />
            </svg>
            <span className="text-sm font-medium text-gray-700">Filtres</span>
            <i className="fas fa-chevron-down text-xs text-gray-700"></i>
          </button>

          {activeMonitoringTab === "zones" && (
            <div
              className="relative flex items-center border border-gray-300 rounded-full overflow-hidden bg-white"
              style={{ height: "40px" }}
            >
              <span
                ref={labelMeasureRef}
                className="absolute invisible text-sm font-medium text-gray-700 whitespace-nowrap"
                style={{
                  left: "-9999px",
                  paddingLeft: "1rem",
                  paddingRight: "1rem",
                }}
              >
                {t("Sort by")}
              </span>
              <span
                className="text-sm font-medium text-gray-700 px-4 whitespace-nowrap flex-shrink-0"
                style={{ width: `${labelWidth}px` }}
              >
                {t("Sort by")}
              </span>
              <div className="relative flex-shrink-0">
                <span
                  ref={measureRef}
                  className="absolute invisible text-sm font-medium text-gray-700 whitespace-nowrap"
                  style={{ left: "-9999px" }}
                >
                  {getSelectedOptionText()}
                </span>
                <select
                  ref={selectRef}
                  value={fieldSort || "filling_level"}
                  onChange={(e) => setFieldSort(e.target.value)}
                  className="flex items-center gap-2 px-[10px] pr-6 h-full bg-white hover:bg-gray-50 transition-colors border-0 text-sm font-medium text-gray-700 cursor-pointer appearance-none outline-none"
                  style={{ width: `${selectWidth}px` }}
                >
                  <option value="filling_level">{t("Filling")}</option>
                  <option value="predictionOverflow">
                    {t("Overflow prediction")}
                  </option>
                  <option value="wasteName">{t("Waste Category")}</option>
                  <option value="addressId">{t("Address")}</option>
                  <option value="status">{t("Status")}</option>
                </select>
                <i className="fas fa-chevron-down text-xs text-gray-700 pointer-events-none absolute right-2 top-1/2 -translate-y-1/2"></i>
              </div>
            </div>
          )}

          {(activeMonitoringTab === "zones" ||
            activeMonitoringTab === "planning") && (
            <div
              className="flex items-center border border-gray-300 rounded-full overflow-hidden"
              style={{ height: "40px" }}
            >
              <div className="flex items-center gap-2 px-4 bg-gray-50 h-full">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2C11.31 2 14 4.69 14 8C14 11.31 11.31 14 8 14Z"
                    fill="#6B7280"
                  />
                  <path
                    d="M8.5 4H7V9L11.25 11.15L12 9.92L8.5 8.25V4Z"
                    fill="#6B7280"
                  />
                </svg>
                <span className="text-sm text-gray-600 whitespace-nowrap">
                  {lastEnrichmentTime
                    ? (() => {
                        const diff = Date.now() - lastEnrichmentTime;
                        const minutes = Math.floor(diff / 60000);

                        if (minutes === 0) {
                          return t("just now");
                        } else if (minutes === 1) {
                          return t("1 min ago");
                        } else if (minutes < 60) {
                          return t("{{count}} min ago", { count: minutes });
                        } else {
                          const hours = Math.floor(minutes / 60);
                          return hours === 1
                            ? t("1h ago")
                            : t("{{count}}h ago", { count: hours });
                        }
                      })()
                    : t("Never refreshed")}
                </span>
              </div>
              <button
                onClick={onRefresh}
                disabled={isEnriching}
                className="flex items-center gap-2 px-4 h-full bg-white hover:bg-gray-50 transition-colors border-l border-gray-300"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={isEnriching ? "animate-spin" : ""}
                >
                  <path
                    d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <span className="text-sm font-medium text-gray-700">
                  {isEnriching ? "..." : t("Refresh")}
                </span>
              </button>
            </div>
          )}
        </div>

        {activeMonitoringTab === "zones" &&
          screenWidth > screenWidthToForceBlockDisplay && (
            <button
              className="create-button flex items-center gap-2 justify-center bg-white border border-gray-300 hover:bg-gray-50 transition-colors"
              onClick={handleDisplayMode}
              style={{
                width: `${displayButtonWidth}px`,
                backgroundColor: "#fff",
                borderColor: "#d1d5db",
                height: "40px",
              }}
            >
              <span
                ref={displayMeasureRef}
                className="absolute invisible text-sm text-gray-700 whitespace-nowrap"
                style={{ left: "-9999px" }}
              >
                {t("Display")}{" "}
                <span className="font-bold">
                  {displayToBlock ? t("List view") : t("Map view")}
                </span>
              </span>
              <span className="text-sm text-gray-700">
                {t("Display")}{" "}
                <span className="font-bold">
                  {displayToBlock ? t("List view") : t("Map view")}
                </span>
              </span>
              <i className="fas fa-chevron-down text-xs text-gray-700"></i>
            </button>
          )}
      </div>
      {filterActive && (
        <Card className="card-filter" style={{ marginTop: "40px" }}>
          <section className="top-filter w-full">
            <div className="table-filter">
              {positioningKeys && positioningKeys.length > 0 ? (
                <>
                  <div className="filter-name">
                    <i className="fas fa-map-marker-alt ico-action"></i>
                    <span>{t("Positioning")}</span>
                  </div>
                  <Multiselect
                    options={positioningKeys}
                    placeholder={t("Select a value")}
                    displayValue="name"
                    onSelect={(value) => setPositioningKeysFiltered(value)}
                    onRemove={(value) => setPositioningKeysFiltered(value)}
                    ref={multiselectPositioningRef}
                    showArrow={true}
                    hidePlaceholder={true}
                    selectedValues={positioningKeysFiltered}
                  />
                </>
              ) : (
                <>
                  <span className="filter-name">{t("Container Id")}</span>
                  <input
                    className="operation-sort h-10 rounded"
                    type="text"
                    id="word"
                    name="word"
                    value={keywordFilter.length > 0 ? keywordFilter[0].key : ""}
                    placeholder={`${t("ID")} : 35, 670`}
                    onChange={(event) =>
                      setKeywordFilter([
                        { type: "id", key: event.target.value },
                      ])
                    }
                  ></input>
                </>
              )}
            </div>

            <div className="table-filter">
              <div className="filter-name">
                <i className="fas fa-tag ico-action"></i>
                <span>{t("Status")}</span>
              </div>
              <Multiselect
                options={statusKeys}
                placeholder={t("Select a value")}
                displayValue="key"
                onSelect={(value) => setStatusKeysFiltered(value)}
                onRemove={(value) => setStatusKeysFiltered(value)}
                ref={multiselectStatusRef}
                showArrow={true}
                hidePlaceholder={true}
                selectedValues={statusKeysFiltered}
              />
            </div>

            <div className="table-filter">
              <div className="filter-name">
                <i className="fas fa-archive ico-action"></i>
                <span>{t("Container type")}</span>
              </div>
              <Multiselect
                options={typeKeys}
                placeholder={t("Filter by type")}
                displayValue="key"
                onSelect={(value) => setTypeKeysFiltered(value)}
                onRemove={(value) => setTypeKeysFiltered(value)}
                ref={multiselectTypeRef}
                showArrow={true}
                hidePlaceholder={true}
                selectedValues={typeKeysFiltered}
              />
            </div>

            <div className="table-filter">
              <div className="filter-name">
                <i className="fas fa-layer-group ico-action"></i>
                <span>
                  Volume m<sup>3</sup>
                </span>
              </div>
              <Multiselect
                options={volumeKeys}
                placeholder={t("Filter by volume")}
                displayValue="key"
                onSelect={(value) => setVolumeKeysFiltered(value)}
                onRemove={(value) => setVolumeKeysFiltered(value)}
                ref={multiselectVolumeRef}
                showArrow={true}
                hidePlaceholder={true}
                selectedValues={volumeKeysFiltered}
              />
            </div>

            <div className="table-filter">
              <div className="filter-name">
                <i className="fas fa-leaf ico-action"></i>
                <span>{t("Material")}</span>
              </div>
              <Multiselect
                options={contentKeys}
                placeholder={t("Filter by waste")}
                displayValue="key"
                onSelect={(value) => setContentKeysFiltered(value)}
                onRemove={(value) => setContentKeysFiltered(value)}
                ref={multiselectContentRef}
                showArrow={true}
                hidePlaceholder={true}
                selectedValues={contentKeysFiltered}
              />
            </div>

            <div className="table-filter">
              <div className="filter-name">
                <i className="fas fa-map-pin ico-action"></i>
                <span>{t("Near")}</span>
              </div>
              <Multiselect
                options={addressKeys}
                placeholder={t("Filter by address")}
                displayValue="key"
                onSelect={(value) => setAddressKeysFiltered(value)}
                onRemove={(value) => setAddressKeysFiltered(value)}
                ref={multiselectAddressRef}
                showArrow={true}
                selectionLimit={1}
                hidePlaceholder={true}
                selectedValues={addressKeysFiltered}
              />
            </div>

            <div className="table-filter">
              <span className="filter-name">{t("Filling level")}</span>
              <ReactSlider
                className="horizontal-slider"
                thumbClassName="example-thumb"
                thumbActiveClassName="example-active-thumb"
                trackClassName="example-track"
                value={arrayFilterFillingLevel}
                ariaLabel={["Lower thumb", "Upper thumb"]}
                ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
                renderThumb={(props, state) => (
                  <div {...props}>{state.valueNow}</div>
                )}
                minDistance={10}
                onAfterChange={(value) => {
                  setArrayFilterFIllingLevel(value);
                }}
                pearling
              />
              <div className="label-slider-value">
                <p>0%</p>
                <p>100%</p>
              </div>
            </div>

            <div className="table-filter">
              <div className="filter-name">
                <i className="fas fa-clock ico-action"></i>
                <span>{t("State at")}</span>
              </div>
              <Multiselect
                options={listHours}
                placeholder={t("Filter by schedule")}
                displayValue="key"
                onSelect={(selectedList) => setHourKeysFiltered(selectedList)}
                onRemove={(selectedList) => setHourKeysFiltered(selectedList)}
                ref={multiselectHour}
                showArrow={true}
                selectionLimit={1}
                hidePlaceholder={true}
                selectedValues={hourKeysFiltered}
              />
            </div>

            <div className="table-filter">
              <TableFilterClearLink
                visible={showClearFilters}
                onClear={cleanFilters}
              />
            </div>

            <div className="table-filter"></div>
          </section>
        </Card>
      )}
      <Modal isOpen={isOpen} toggle={() => toggle()} className="w-2/6">
        <section className="flex justify-end py-2 px-2 border-b-1">
          <FontAwesomeIcon
            icon="times"
            className="close-modal"
            onClick={() => toggle()}
          />
        </section>
        <section className="bg-white rounded-md p-3 w-auto">
          <FormGroup>
            <Input
              id="action"
              name="action"
              type="select"
              onChange={(event) => {
                setAction(event.target.value);
                setUserToSendMail([]);
              }}
              value={action}
            >
              <option value="export">{`${t("Export")} PDF (.pdf)`}</option>
              <option value="share">{t("Share by email")}</option>
            </Input>
          </FormGroup>
          {action === "share" && (
            <Fragment>
              <FormGroup>
                <Label for="user">{t("Recipient")}</Label>
                <ReactMultiEmail
                  placeholder={t("Recipient")}
                  emails={userToSendMail}
                  onChange={(emails) => setUserToSendMail(emails)}
                  autoFocus={true}
                  getLabel={(email, index, removeEmail) => {
                    return (
                      <div data-tag key={index}>
                        <div data-tag-item>{email}</div>
                        <span
                          data-tag-handle
                          onClick={() => removeEmail(index)}
                        >
                          ×
                        </span>
                      </div>
                    );
                  }}
                />
              </FormGroup>
              <FormGroup>
                <Label for="subject">{t("Subject")}</Label>
                <Input
                  className="text-sm"
                  id="subject"
                  name="subject"
                  placeholder={t("Subject")}
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <Label for="message">{t("Message")}</Label>
                <Input
                  className="text-sm h-24"
                  id="message"
                  name="message"
                  placeholder={t("Message")}
                  type="textarea"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </FormGroup>
            </Fragment>
          )}
          {pdfFiles.length > 0 && (
            <FormGroup>
              <Label htmlFor="file">{t("File")}</Label>
              {pdfFiles.map((file, index) => {
                const blobUrl = URL.createObjectURL(file.pdfBlob); // créer un lien de téléchargement
                return (
                  <div
                    key={index}
                    className="flex justify-between py-1 px-2 items-center border-t-1 border-gray-200"
                  >
                    <div className="flex flex-row gap-2 items-center">
                      <i className="fas fa-file-pdf text-red-500"></i>
                      <a
                        href={blobUrl}
                        download={file.filename}
                        className="text-blue-600 hover:underline"
                      >
                        {file.filename}
                      </a>
                    </div>
                    <i
                      className="fas fa-times text-gray-500 hover:text-red cursor-pointer"
                      onClick={() => handleRemovePdf(index)}
                    ></i>
                  </div>
                );
              })}
            </FormGroup>
          )}
        </section>

        <div className="w-full flex flex-end gap-2 pr-3 py-2 border-t-1">
          {action === "export" ? (
            <button
              type="button"
              className={`p-2 text-sm font-medium text-white rounded-sm ${pdfFiles.length > 0 ? "bg-[#00A7A6]" : "bg-[#DCDCDC]"}`}
              onClick={() => {
                if (pdfFiles.length > 0) {
                  downloadPdf();
                }
              }}
            >
              {t("Export")}
            </button>
          ) : (
            <button
              type="button"
              className={`p-2 text-sm font-medium text-white rounded-sm ${userToSendMail !== "" ? "bg-[#00A7A6]" : "bg-[#DCDCDC]"}`}
              onClick={() => {
                if (userToSendMail !== "") {
                  sendMail();
                }
              }}
            >
              {t("Share")}
            </button>
          )}
        </div>
      </Modal>
      {loadScreen && <LoadingScreen />}
    </>
  );
};

export default ContainerFilter;
